import React, { Component } from 'react'
import { Button, CardActions } from 'react-md'
import { reduxForm } from 'redux-form'

class ViewHeader extends Component {
  render () {
    const {
      disableDelete,
      disableGoBack,
      handleSubmit,
      onGoBack,
      onDelete,
      pristine,
      reset,
      submitting
    } = this.props

    return (
      <div className='artwork-view-header'>

        <CardActions className='view-actions view-actions--left'>
          { !disableGoBack && (
            <Button flat iconChildren='navigate_before' onClick={onGoBack}>
              Back
            </Button>
          ) }
        </CardActions>

        <CardActions className='view-actions view-actions--right'>
          { !disableDelete && (
            <Button flat iconChildren='delete' onClick={onDelete}>
              Delete
            </Button>
          ) }

          <div>
            <Button
              flat
              iconChildren='keyboard_backspace'
              onClick={reset}
              disabled={pristine || submitting}
            >
              Undo
            </Button>
            <Button
              flat
              primary
              iconChildren='cloud'
              onClick={handleSubmit}
              disabled={pristine || submitting}
            >
              Save
            </Button>
          </div>
        </CardActions>

      </div>
    )
  }
}

export default reduxForm({
  form: 'user-details',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  pure: false
})(ViewHeader)



// WEBPACK FOOTER //
// ./src/containers/User/View/ViewHeader/index.js